import { HttpClient, HttpParams } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable } from "rxjs";

import { AppConfigService } from "@core/services/config.service";
import { Discount } from "@core/models/discount";

export class DiscountService {
  private readonly http = inject(HttpClient);
  private readonly appConfigService = inject(AppConfigService);

  private readonly apiBaseUrl = `${this.appConfigService.host()}`;

  /**
   * Get discount by code
   * @param code - The coupon or voucher code
   * @param sellerId - The seller id (required)
   * @param eventId - The event id (optional)
   * @returns The discount
   * @description The API provides information on both coupons and vouchers.
   * If there is a coupon and a voucher with the same code, and an eventId is provided, the coupon will be preferred.
   * Without providing an eventId, only vouchers will be considered.
   */
  getDiscount(code: string, sellerId: string, eventId?: string): Observable<Discount> {
    let params = new HttpParams().set('sellerId', sellerId);
    if (eventId) {
      params = params.set('eventId', eventId);
    }
    return this.http.get<Discount>(`${this.apiBaseUrl}/coupon/${code}/info`, { params });
  }
}